import './ActionButton.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var disabled = '_otmjah3-3-15-1';
export var navItem = _7a468({defaultClassName:'_otmjah0-3-15-1',variantClassNames:{density:{'default':'_otmjah1-3-15-1',condensed:'_otmjah2-3-15-1'}},defaultVariants:{},compoundVariants:[]});
export var navItemSelectionStyle = '_otmjah4-3-15-1';